import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// import { v4 as uuidv4 } from 'uuid';
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import ProductsModule from "@/store/modules/productsApps.module";
import { ProductsaddModel } from "@/store/models/productsApps/ProductaddDTO";
import { ProductsModel } from "@/store/models/productsApps/productsList";
import { ProductsEditModel } from "@/store/models/productsApps/ProductEditDTO";
import { ProductsViewModel } from "@/store/models/productsApps/productViewDTO";
setInteractionMode("passive");
let Products = /** @class */ (() => {
    let Products = class Products extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.items = [
                {
                    text: "Products",
                },
                {
                    text: "AddProducts",
                    active: true,
                },
            ];
            this.title = "Products";
            this.pageIsLoading = true;
            this.showNewProductList = false;
            this.product = new ProductsModel();
            this.selectedProduct = new ProductsaddModel();
            this.selectedEditProduct = new ProductsEditModel();
            this.selectedViewProduct = new ProductsViewModel();
        }
        // EVENT WIRINGS
        openNewProductList() {
            this.product = new ProductsModel();
            this.showNewProductList = true;
            this.$router.push({ name: "AddProducts" });
        }
        editProduct(productId) {
            this.$router.push({ name: "EditProducts", params: { productId } });
        }
        ViewProduct(viewProductId) {
            this.$router.push({ name: "ViewProducts", params: { viewProductId } });
        }
        // COMPUTED
        get products() {
            return ProductsModule.products;
        }
        // LIFECYCLE
        created() {
            ProductsModule.GetAllUsers().then((response) => {
                this.pageIsLoading = false;
            });
        }
    };
    Products = __decorate([
        Component({
            name: "Products",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], Products);
    return Products;
})();
export default Products;
